import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, Input, OnDestroy, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { MEDIA_TOKEN } from '../../../../../tockens';

@Component({
    selector: 'clever-flugfilter',
    templateUrl: './flugfilter.component.html',
    styleUrls: ['./flugfilter.component.scss'],
    standalone: false
})
export class FlugfilterComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() israiltravel: boolean;
    @Input() type: string;
    @Input() realparams: ParamFilters;
    @Input() reference: string;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showMore: boolean = false;
    smallVersion: boolean = true;
    media: string = 'lg';
    btntext: string = 'FLUG FINDEN';
    start: string;
    end: string;
    filter: ParamFilters;

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected hotelFilters: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.initFilterSub();
        this.initFilters();
        this.initMedia();
    }

    initMedia(): void {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    gotoZiel(): void {
        this.smallVersion = true;
        this.hotelFilters.setReference(this.reference);
        this.hotelFilters.gotoUrlFlug(this.type);
    }

    showMBMenu(): void {
        this.smallVersion = false;
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
        if (!this.showMore) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    initFilters(): void {
        if (this.realparams) {
            this.hotelFilters.onlySetRealParams(this.realparams);
        } else if (this.mode === 'home') {
            this.hotelFilters.resetAllExtrasHome();
        }
    }

    switchType(type): void {
        this.type = type;
        this.hotelFilters.onlySetProductType(this.type);
    }

    initFilterSub(): void {
        this.hotelFilters.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            if (filter) {
                this.filter = JSON.parse(JSON.stringify(filter));
                this.initDate(filter);
            }
            this.cdr.detectChanges();
        });
    }

    async initDate(filter) {
        const reg = new RegExp('^\\d+,\\d+,\\d+$');
        if (String(filter?.reisezeitraumResult).match(reg)) {
            const tmp = String(filter?.reisezeitraumResult).split(',');
            this.start = moment().add(tmp[0], 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(tmp[1]) + Number(tmp[0]), 'days').format('YYYY-MM-DD');
        } else if (filter?.reisezeitraumResult?.start?.length > 0) {
            this.start = moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD');
            this.end = moment(filter.reisezeitraumResult.end).format('YYYY-MM-DD');
        } else if (!isNaN(Number(filter?.reisezeitraumResult?.start))) {
            this.start = moment().add(Number(filter.reisezeitraumResult.start), 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(filter.reisezeitraumResult.end), 'days').format('YYYY-MM-DD');
        } else {
            this.start = moment().add(4, 'days').format('YYYY-MM-DD');
            this.end = moment().add(180, 'days').format('YYYY-MM-DD');
        }
        this.cdr.detectChanges();
    }

    async selectValue(ev) {
        this.hotelFilters.reisezeitraumResult(ev.start, ev.end);
    }

    async resTraveler(ev) {
        this.hotelFilters.reisendeResult(ev);
    }
}
